import axios from 'axios'
import serverURL from './serverURL'
import getDeviceId from './deviceId'

const api = axios.create({
    baseURL: serverURL,
})

// Setado aqui (na avaliação do módulo, antes de qualquer render do React) e não
// num useEffect do useAuth: efeitos de componentes filhos disparam antes do
// efeito do UserProvider (que envolve o app inteiro), então a primeira
// requisição de qualquer página após um F5/aba nova saía sem X-Device-Id —
// verifyToken.js rejeitava com "Sessão inválida para este dispositivo" mesmo
// sendo o mesmo navegador, derrubando a sessão logo de cara.
const storedToken = localStorage.getItem('token')
if (storedToken) {
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(storedToken)}`
}
api.defaults.headers['X-Device-Id'] = getDeviceId()

// Sessão deslizante: o backend reassina o token a cada requisição autenticada
// e manda o novo no header x-renewed-token — aqui a gente só precisa guardar
// esse token pra sessão só expirar se o usuário ficar parado o período inteiro.
//
// Sessão expirada ou token inválido: desloga e manda pro login em vez de
// deixar a tela travada esperando uma resposta que nunca vai vir certa.
api.interceptors.response.use(
    (response) => {
        const renewedToken = response.headers['x-renewed-token']
        if (renewedToken) {
            localStorage.setItem('token', JSON.stringify(renewedToken))
            // Sem isso, requisições seguintes na mesma aba continuam usando o
            // token antigo (só o localStorage é atualizado) até a próxima
            // recarga de página — a sessão deslizante não escorregava de
            // verdade dentro de uma sessão longa sem reload.
            api.defaults.headers.Authorization = `Bearer ${renewedToken}`
        }
        return response
    },
    (error) => {
        if (error.response?.status === 401 && window.location.pathname !== '/login') {
            localStorage.removeItem('token')
            localStorage.removeItem('userName')

            // sessionStorage porque o redirecionamento a seguir recarrega a
            // página inteira — um bus.emit direto não sobreviveria até lá.
            sessionStorage.setItem('pendingFlash', JSON.stringify({
                message: error.response.data?.message || 'Sessão expirada. Faça login novamente.',
                type: 'error',
            }))

            window.location.href = '/login'
        }
        return Promise.reject(error)
    }
)

export default api
